import { API_Endpoints } from "./API_Endpoints";
import axiosInstance from "./axios";
export const GetUserDetails = () => {
  return axiosInstance
    .get(`${API_Endpoints.Users.USER_DETAILS}`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const GetUsersService = (
  page?: number,
  limit?: number,
  type?: { type?: any }
) => {
  return axiosInstance
    .post(`${API_Endpoints.Admin.GET_USERS}?page=${page}&limit=${limit}`, type)
    .then((res) => res.data)
    .catch((err) => err);
};

export const DeleteUserService = (user_id: number) => {
  return axiosInstance
    .delete(`${API_Endpoints.Admin.DELETE_USER}/${user_id}`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const ChangeUserStatusService = (data: any) => {
  return axiosInstance
    .post(`${API_Endpoints.Admin.CHANGE_USER_STATUS}/${data.id}`, {
      status: data.status,
    })
    .then((res) => res.data)
    .catch((err) => err);
};
export const GetAdminUserDetail = (id: any) => {
  return axiosInstance
    .get(`${API_Endpoints.Admin.GET_USER_DETAIL}/${id}`)
    .then((res) => res.data)
    .catch((err) => err);
};
export const UpdateAdminUserProfile = (data: any, id: any) => {
  return axiosInstance
    .put(`${API_Endpoints.Admin.UPDATE_USER_PROFILE}/${data.id}`, data)
    .then((res) => res.data)
    .catch((err) => err);
};
